<template>
  <div id="contact-projects">
    <div class="row mt-3 mx-0">
      <div class="col-12">
        <div class="report-date-filter text-right">
          <div class="alert alert-warning">
            เลือก ช่วงเวลา ที่ต้องการก่อนกด Download Report
          </div>
          <span class="mr-3">คัดกรองจากวันที่</span>
          <el-date-picker
            v-model="defaultReportDate"
            format="dd-MM-yyyy HH:mm"
            start-placeholder="เริ่ม"
            end-placeholder="สิ้นสุด"
            range-separator="ถึง"
            type="datetimerange"
            @change="dateFilter"
          />
        </div>
      </div>
    </div>
    <div class="row mt-3 mx-0">
      <div class="col-12">
        <div class="text-right">
          <sc-button variant="secondary" @click="handleClickDownloadReport"
            >Download Report</sc-button
          >
          <download-excel
            class="sc-btn sc-btn-outline"
            :fields="statField"
            :data="conversationStatData"
            type="xls"
            name="project-conversation-stat.xls"
            :before-generate="getProjectsData"
            >ดาวน์โหลดข้อมูลโครงการ</download-excel
          >
        </div>
      </div>
    </div>
    <div class="col row px-0 mx-0" style="height: calc(94% - 148px - 112px)">
      <div
        v-if="!isAllowedRoles([
          permissionRole.WSADMIN,
          permissionRole.NS
        ])"
        class="col-6 d-flex"
        style="height: 100%"
      >
        <div class="card col px-0 d-flex flex-column">
          <div class="card-header bg-warning text-white">
            <div class="media">
              <div class="media-body h2 text-white">
                {{ $t("feature.contact.project.low_rise") }}
              </div>
              <div class="ml-3">
                <search-input
                  @search="lowChange"
                  :placeholder="
                    $t('feature.contact.search.project_title_or_project_code')
                  "
                ></search-input>
              </div>
            </div>
          </div>
          <ul class="list-group list-group-flush">
            <li
              class="list-group-item"
              v-for="project in projectsPresenter.lowRise.projects"
              :key="project.id"
              @click="selectProject(project)"
            >
              <div class="media">
                <div class="mr-2">
                  <img :src="project.icon" class="project-icon" />
                </div>
                <div class="media-body">
                  <div class="h4">
                    {{ project.name }}
                  </div>
                  <div class="h5">
                    {{ project.location }}
                  </div>
                </div>

                <div class="ml-3 mt-2 h3">
                  {{ project.code }}
                </div>
                <div class="ml-2 mt-1">
                  <span class="px-2 badge" v-show="project.unread > 0">{{
                    project.unread
                  }}</span>
                </div>
              </div>
              <hr />
              <div class="stat">
                <div class="col">
                  <h6 class="stat-ttl">Conversation ทั้งหมด</h6>
                  <div class="count">
                    {{ project.contactStat.all }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">Conversation ที่กำลังดำเนินการ</h6>
                  <div class="count">
                    {{ project.contactStat.active }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">Conversation ที่ปิดแล้ว</h6>
                  <div class="count">
                    {{ project.contactStat.closed }}
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item py-3">
              <div class="media pt-2">
                <div class="media-body">
                  <div class="h4">ผลรวมทุกโครงการ<br /><br /></div>
                </div>
              </div>
              <div class="stat">
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>Conversation ทั้งหมด</strong>
                  </h6>
                  <div class="count">
                    {{ projectsPresenter.lowRise.totalStat.all }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>Conversation ที่กำลังดำเนินการ</strong>
                  </h6>
                  <div class="count">
                    {{ projectsPresenter.lowRise.totalStat.active }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>Conversation ที่ปิดแล้ว</strong>
                  </h6>
                  <div class="count">
                    {{ projectsPresenter.lowRise.totalStat.closed }}
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div
        v-if="!isAllowedRoles([
          permissionRole.WSADMIN,
          permissionRole.NS
        ])"
        class="col-6 d-flex"
        style="height: 100%"
      >
        <div class="card col px-0 d-flex flex-column">
          <div class="card-header bg-success text-white">
            <div class="media">
              <div class="media-body h2 text-white">
                {{ $t("feature.contact.project.high_rise") }}
              </div>
              <div class="ml-3">
                <search-input
                  @search="highChange"
                  :placeholder="
                    $t('feature.contact.search.project_title_or_project_code')
                  "
                ></search-input>
              </div>
            </div>
          </div>
          <ul class="list-group list-group-flush">
            <li
              class="list-group-item"
              v-for="project in projectsPresenter.highRise.projects"
              :key="project.id"
              @click="selectProject(project)"
            >
              <div class="media">
                <div class="mr-2">
                  <img :src="project.icon" class="project-icon" />
                </div>
                <div class="media-body">
                  <div class="h4">
                    {{ project.name }}
                  </div>
                  <div class="h5">
                    {{ project.location }}
                  </div>
                </div>
                <div class="ml-3 mt-2 h3">
                  {{ project.code }}
                </div>
                <div class="ml-2 mt-1">
                  <span class="px-2 badge" v-show="project.unread > 0">{{
                    project.unread
                  }}</span>
                </div>
              </div>
              <hr />
              <div class="stat">
                <div class="col">
                  <h6 class="stat-ttl">Conversation ทั้งหมด</h6>
                  <div class="count">
                    {{ project.contactStat.all }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">Conversation ที่กำลังดำเนินการ</h6>
                  <div class="count">
                    {{ project.contactStat.active }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">Conversation ที่ปิดแล้ว</h6>
                  <div class="count">
                    {{ project.contactStat.closed }}
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item py-3">
              <div class="media pt-2">
                <div class="media-body">
                  <div class="h4">ผลรวมทุกโครงการ<br /><br /></div>
                </div>
              </div>
              <div class="stat">
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>Conversation ทั้งหมด</strong>
                  </h6>
                  <div class="count">
                    {{ projectsPresenter.highRise.totalStat.all }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>Conversation ที่กำลังดำเนินการ</strong>
                  </h6>
                  <div class="count">
                    {{ projectsPresenter.highRise.totalStat.active }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>Conversation ที่ปิดแล้ว</strong>
                  </h6>
                  <div class="count">
                    {{ projectsPresenter.highRise.totalStat.closed }}
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div
        v-if="isAllowedRoles([
          permissionRole.NS,
          permissionRole.CC,
          permissionRole.SADMIN,
          permissionRole.LMA,
          permissionRole.LMC,
          permissionRole.LMM
        ])"
        class="col-6 d-flex"
        style="height: 100%"
      >
        <div class="card col px-0 d-flex flex-column">
          <div class="card-header bg-success text-white">
            <div class="media">
              <div class="media-body h2 text-white">
                {{ $t("feature.contact.project.non_sc_low_rise") }}
              </div>
              <div class="ml-3">
                <search-input
                  @search="noneSCLowChange"
                  :placeholder="
                    $t('feature.contact.search.project_title_or_project_code')
                  "
                ></search-input>
              </div>
            </div>
          </div>
          <ul class="list-group list-group-flush">
            <li
              class="list-group-item"
              v-for="project in projectsPresenter.noneSCLowRise.projects"
              :key="project.id"
              @click="selectProject(project)"
            >
              <div class="media">
                <div class="mr-2">
                  <img :src="project.icon" class="project-icon" />
                </div>
                <div class="media-body">
                  <div class="h4">
                    {{ project.name }}
                  </div>
                  <div class="h5">
                    {{ project.location }}
                  </div>
                </div>
                <div class="ml-3 mt-2 h3">
                  {{ project.code }}
                </div>
                <div class="ml-2 mt-1">
                  <span class="px-2 badge" v-show="project.unread > 0">{{
                    project.unread
                  }}</span>
                </div>
              </div>
              <hr />
              <div class="stat">
                <div class="col">
                  <h6 class="stat-ttl">Conversation ทั้งหมด</h6>
                  <div class="count">
                    {{ project.contactStat.all }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">Conversation ที่กำลังดำเนินการ</h6>
                  <div class="count">
                    {{ project.contactStat.active }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">Conversation ที่ปิดแล้ว</h6>
                  <div class="count">
                    {{ project.contactStat.closed }}
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item py-3">
              <div class="media pt-2">
                <div class="media-body">
                  <div class="h4">ผลรวมทุกโครงการ<br /><br /></div>
                </div>
              </div>
              <div class="stat">
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>Conversation ทั้งหมด</strong>
                  </h6>
                  <div class="count">
                    {{ projectsPresenter.noneSCLowRise.totalStat.all }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>Conversation ที่กำลังดำเนินการ</strong>
                  </h6>
                  <div class="count">
                    {{ projectsPresenter.noneSCLowRise.totalStat.active }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>Conversation ที่ปิดแล้ว</strong>
                  </h6>
                  <div class="count">
                    {{ projectsPresenter.noneSCLowRise.totalStat.closed }}
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div
        v-if="isAllowedRoles([
          permissionRole.NS,
          permissionRole.CC,
          permissionRole.SADMIN,
          permissionRole.LMA,
          permissionRole.LMC,
          permissionRole.LMM
        ])"
        class="col-6 d-flex"
        style="height: 100%"
      >
        <div class="card col px-0 d-flex flex-column">
          <div class="card-header bg-success text-white">
            <div class="media">
              <div class="media-body h2 text-white">
                {{ $t("feature.contact.project.non_sc_high_rise") }}
              </div>
              <div class="ml-3">
                <search-input
                  @search="noneSCHighChange"
                  :placeholder="
                    $t('feature.contact.search.project_title_or_project_code')
                  "
                ></search-input>
              </div>
            </div>
          </div>
          <ul class="list-group list-group-flush">
            <li
              class="list-group-item"
              v-for="project in projectsPresenter.noneSCHighRise.projects"
              :key="project.id"
              @click="selectProject(project)"
            >
              <div class="media">
                <div class="mr-2">
                  <img :src="project.icon" class="project-icon" />
                </div>
                <div class="media-body">
                  <div class="h4">
                    {{ project.name }}
                  </div>
                  <div class="h5">
                    {{ project.location }}
                  </div>
                </div>
                <div class="ml-3 mt-2 h3">
                  {{ project.code }}
                </div>
                <div class="ml-2 mt-1">
                  <span class="px-2 badge" v-show="project.unread > 0">{{
                    project.unread
                  }}</span>
                </div>
              </div>
              <hr />
              <div class="stat">
                <div class="col">
                  <h6 class="stat-ttl">Conversation ทั้งหมด</h6>
                  <div class="count">
                    {{ project.contactStat.all }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">Conversation ที่กำลังดำเนินการ</h6>
                  <div class="count">
                    {{ project.contactStat.active }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">Conversation ที่ปิดแล้ว</h6>
                  <div class="count">
                    {{ project.contactStat.closed }}
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item py-3">
              <div class="media pt-2">
                <div class="media-body">
                  <div class="h4">ผลรวมทุกโครงการ<br /><br /></div>
                </div>
              </div>
              <div class="stat">
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>Conversation ทั้งหมด</strong>
                  </h6>
                  <div class="count">
                    {{ projectsPresenter.noneSCHighRise.totalStat.all }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>Conversation ที่กำลังดำเนินการ</strong>
                  </h6>
                  <div class="count">
                    {{ projectsPresenter.noneSCHighRise.totalStat.active }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>Conversation ที่ปิดแล้ว</strong>
                  </h6>
                  <div class="count">
                    {{ projectsPresenter.noneSCHighRise.totalStat.closed }}
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div
        v-if="isAllowedRoles([
          permissionRole.WSADMIN,
          permissionRole.CC,
          permissionRole.SADMIN
        ])"
        class="col-12 d-flex"
        style="height: 100%"
      >
        <div class="card col px-0 d-flex flex-column">
          <div class="card-header bg-info text-white">
            <div class="media">
              <div class="media-body h2 text-white">
                {{ $t("feature.contact.project.building") }}
              </div>
              <div class="ml-3">
                <search-input
                  @search="buildingChange"
                  :placeholder="
                    $t('feature.contact.search.building_title_or_building_code')
                  "
                ></search-input>
              </div>
            </div>
          </div>
          <ul class="list-group list-group-flush">
            <li
              class="list-group-item"
              v-for="project in projectsPresenter.buildingRise.projects"
              :key="project.id"
              @click="selectProject(project)"
            >
              <div class="media">
                <div class="mr-2">
                  <img :src="project.icon" class="project-icon" />
                </div>
                <div class="media-body">
                  <div class="h4">
                    {{ project.name }}
                  </div>
                  <div class="h5">
                    {{ project.location }}
                  </div>
                </div>
                <div class="ml-3 mt-2 h3">
                  {{ project.code }}
                </div>
                <div class="ml-2 mt-1">
                  <span class="px-2 badge" v-show="project.unread > 0">{{
                    project.unread
                  }}</span>
                </div>
              </div>
              <hr />
              <div class="stat">
                <div class="col">
                  <h6 class="stat-ttl">Conversation ทั้งหมด</h6>
                  <div class="count">
                    {{ project.contactStat.all }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">Conversation ที่กำลังดำเนินการ</h6>
                  <div class="count">
                    {{ project.contactStat.active }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">Conversation ที่ปิดแล้ว</h6>
                  <div class="count">
                    {{ project.contactStat.closed }}
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item py-3">
              <div class="media pt-2">
                <div class="media-body">
                  <div class="h4">ผลรวมทุกโครงการ<br /><br /></div>
                </div>
              </div>
              <div class="stat">
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>Conversation ทั้งหมด</strong>
                  </h6>
                  <div class="count">
                    {{ projectsPresenter.buildingRise.totalStat.all }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>Conversation ที่กำลังดำเนินการ</strong>
                  </h6>
                  <div class="count">
                    {{ projectsPresenter.buildingRise.totalStat.active }}
                  </div>
                </div>
                <div class="col">
                  <h6 class="stat-ttl">
                    <strong>Conversation ที่ปิดแล้ว</strong>
                  </h6>
                  <div class="count">
                    {{ projectsPresenter.buildingRise.totalStat.closed }}
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-12">
        <div class="card">
          <div class="card-header h2">
            {{ $t("feature.contact.project.other") }}
          </div>
          <ul class="list-group list-group-flush">
            <li
              class="list-group-item"
              @click="
                selectProject({
                  id: 'OTHER',
                  name: 'Other',
                  projectIcon: ''
                })
              "
            >
              <div class="media">
                <div class="mr-3 mt-2 h3">Other</div>
                <div class="media-body">
                  <div class="h4">
                    {{ $t("feature.contact.visitor.title") }}
                  </div>
                  <div class="h4">
                    {{ $t("feature.contact.visitor.detail") }}
                  </div>
                </div>
                <div class="ml-3 mt-1" v-if="unknownProject.unread > 0">
                  <span class="badge px-2">{{ unknownProject.unread }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JsonExcel from "vue-json-excel";
import { DatePicker } from "element-ui";
import SearchInput from "@/components/helper/SearchInput";
import ScButton from "@/lib/components/ScButton";
import { DateTime } from "luxon";
import { baanRueJaiClient } from "@/dependencies";
import { permissionRole } from "@/lib/mapper";
import { toCamelCaseObject } from "@/lib/util";
import { isNil, isEmpty, sum } from "ramda";

export default {
  components: {
    SearchInput,
    ScButton,
    downloadExcel: JsonExcel,
    elDatePicker: DatePicker
  },
  data() {
    const permission =
      JSON.parse(localStorage.getItem("adminRolePermission")) || null;

    const lowRise = {
      projects: [],
      totalStat: {
        all: 0,
        active: 0,
        closed: 0
      }
    };
    const highRise = {
      projects: [],
      totalStat: {
        all: 0,
        active: 0,
        closed: 0
      }
    };
    const buildingRise = {
      projects: [],
      totalStat: {
        all: 0,
        active: 0,
        closed: 0
      }
    };
    const noneSCLowRise = {
      projects: [],
      totalStat: {
        all: 0,
        active: 0,
        closed: 0
      }
    };
    const noneSCHighRise = {
      projects: [],
      totalStat: {
        all: 0,
        active: 0,
        closed: 0
      }
    };
    const unknownProject = {
      unread: 0
    };
    const searchText = {
      lowRise: "",
      highRise: "",
      buildingRise: "",
      noneSCLowRise: "",
      noneSCHighRise: "",
    };
    const badgesResponse = [];

    return {
      lowRise,
      highRise,
      buildingRise,
      noneSCLowRise,
      noneSCHighRise,
      unknownProject,
      searchText,
      badgesResponse,
      defaultReportDate: ["", ""],
      statField: {
        "Project Name": "projectName",
        "Project Code": "projectCode",
        "Project Type": "projectType",
        "All Conversation": "allConversation",
        "Active Conversationnit": "activeConversation",
        "Closed Conversation": "closedConversation",
        "Contact Conversation": "contactConversation",
        "Comment Conversation": "commentConversation",
        "Complaint Conversation": "complaintConversation",
        "Greeting Conversation": "greetingConversation"
      },
      conversationStatData: [],
      role: permission.role,
      permissionRole
    };
  },
  methods: {
    async initData() {
      await this.setupProjectConversationStats();
    },
    dateFilter() {
      this.setup();
    },
    selectProject(project) {
      this.$store.state.projectName = project.name;
      this.$store.state.projectId = project.id;

      localStorage.setItem("projectName", project.name);
      localStorage.setItem("projectId", project.id);

      this.$router.push({ name: "Contact", params: { contactId: "all" } });
    },
    async setupProjectConversationStats() {
      const dateFilter =
        this.defaultReportDate[0] == "" || this.defaultReportDate[1] == ""
          ? null
          : this.defaultReportDate;

      const headerTotalStatRow = this.createRow(
        "",
        "",
        "",
        "All Conversation",
        "Active Conversation",
        "Closed Conversation",
        "ContactConversation",
        "Comment Conversation",
        "Complaint Conversation",
        "Greeting Conversation"
      );

      if (!this.isAllowedRoles([
          this.permissionRole.WSADMIN,
          this.permissionRole.NS
        ])) {
        const highRiseProjectIds = this.highRise.projects.map(
          project => project.id
        );
        
        const rawHighRiseConversationStats = await this.getProjectConversationStats(
          highRiseProjectIds,
          dateFilter
        );
        const highRiseConversationStats = this.createConversationStats(
          rawHighRiseConversationStats
        );
        const highRiseConversationStatRows = this.createConversationStatRows(
          this.projectsPresenter.highRise.projects,
          highRiseConversationStats,
          "High Rise"
        );
        const highRiseTotalStatRow = this.createTotalStatRow(
          highRiseConversationStatRows
        );

        const lowRiseProjectIds = this.lowRise.projects.map(
          project => project.id
        );
        const rawLowRiseConversationStats = await this.getProjectConversationStats(
          lowRiseProjectIds,
          dateFilter
        );
        const lowRiseConversationStats = this.createConversationStats(
          rawLowRiseConversationStats
        );
        const lowRiseConversationStatRows = this.createConversationStatRows(
          this.projectsPresenter.lowRise.projects,
          lowRiseConversationStats,
          "Low Rise"
        );
        const lowRiseTotalStatRow = this.createTotalStatRow(
          lowRiseConversationStatRows
        );

        const totalStatRow = this.createTotalStatRow([
          ...highRiseConversationStatRows,
          ...lowRiseConversationStatRows
        ]);

        this.conversationStatData = [].concat(
          highRiseConversationStatRows,
          highRiseTotalStatRow,
          lowRiseConversationStatRows,
          lowRiseTotalStatRow,
          headerTotalStatRow,
          totalStatRow
        );
      } else if (this.isAllowedRoles([permissionRole.NS])) {
        const noneSCHighRiseProjectIds = this.noneSCHighRise.projects.map(
          project => project.id
        );
        const rawNoneSCHighRiseConversationStats = await this.getProjectConversationStats(
          noneSCHighRiseProjectIds,
          dateFilter
        );
        const noneSCHighRiseConversationStats = this.createConversationStats(
          rawNoneSCHighRiseConversationStats
        );
        const noneSCHighRiseConversationStatRows = this.createConversationStatRows(
          this.projectsPresenter.noneSCHighRise.projects,
          noneSCHighRiseConversationStats,
          "None SC High Rise"
        );
        const noneSCHighRiseTotalStatRow = this.createTotalStatRow(
          noneSCHighRiseConversationStatRows
        );

        const noneSCLowRiseProjectIds = this.noneSCLowRise.projects.map(
          project => project.id
        );
        const rawNoneSCLowRiseConversationStats = await this.getProjectConversationStats(
          noneSCLowRiseProjectIds,
          dateFilter
        );
        const noneSCLowRiseConversationStats = this.createConversationStats(
          rawNoneSCLowRiseConversationStats
        );
        const noneSCLowRiseConversationStatRows = this.createConversationStatRows(
          this.projectsPresenter.noneSCLowRise.projects,
          noneSCLowRiseConversationStats,
          "None SC Low Rise"
        );
        const noneSCLowRiseTotalStatRow = this.createTotalStatRow(
          noneSCLowRiseConversationStatRows
        );

        const totalStatRow = this.createTotalStatRow([
          ...noneSCHighRiseConversationStatRows,
          ...noneSCLowRiseConversationStatRows
        ]);

        this.conversationStatData = [].concat(
          noneSCHighRiseConversationStatRows,
          noneSCHighRiseTotalStatRow,
          noneSCLowRiseConversationStatRows,
          noneSCLowRiseTotalStatRow,
          headerTotalStatRow,
          totalStatRow
        );
      } else {
        const buildingRiseProjectIds = this.buildingRise.projects.map(
          project => project.id
        );
        const rawBuildingRiseConversationStats = await this.getProjectConversationStats(
          buildingRiseProjectIds,
          dateFilter
        );
        const buildingRiseConversationStats = this.createConversationStats(
          rawBuildingRiseConversationStats
        );
        const buildingRiseConversationStatRows = this.createConversationStatRows(
          this.projectsPresenter.buildingRise.projects,
          buildingRiseConversationStats,
          "Building"
        );
        const buildingRiseTotalStatRow = this.createTotalStatRow(
          buildingRiseConversationStatRows
        );

        const totalStatRow = this.createTotalStatRow(
          buildingRiseConversationStatRows
        );

        this.conversationStatData = [].concat(
          buildingRiseConversationStatRows,
          buildingRiseTotalStatRow,
          headerTotalStatRow,
          totalStatRow
        );
      }
    },
    createConversationStats(projectConversationStats) {
      return projectConversationStats.rows.reduce(
        (projects, currentProject) => {
          const project = projects.find(
            project => project.id == currentProject.project_id
          );

          if (!isNil(project)) {
            project.stat.contact =
              currentProject.contact_category_id == 1
                ? ++project.stat.contact
                : project.stat.contact;
            project.stat.comment =
              currentProject.contact_category_id == 2
                ? ++project.stat.comment
                : project.stat.comment;
            project.stat.complaint =
              currentProject.contact_category_id == 3
                ? ++project.stat.complaint
                : project.stat.complaint;
            project.stat.greeting =
              currentProject.contact_category_id == 4
                ? ++project.stat.greeting
                : project.stat.greeting;

            return projects;
          } else {
            const newProjectStat = {
              id: currentProject.project_id,
              stat: {
                contact: currentProject.contact_category_id == 1 ? 1 : 0,
                comment: currentProject.contact_category_id == 2 ? 1 : 0,
                complaint: currentProject.contact_category_id == 3 ? 1 : 0,
                greeting: currentProject.contact_category_id == 4 ? 1 : 0
              }
            };

            return [...projects, newProjectStat];
          }
        },
        []
      );
    },
    createConversationStatRows(projects, conversationStats, projectType) {
      return projects.map(project => {
        const projectStat = conversationStats.find(
          projectStat => project.id == projectStat.id
        );
        const contactConversation = projectStat ? projectStat.stat.contact : 0;
        const commentConversation = projectStat ? projectStat.stat.comment : 0;
        const complaintConversation = projectStat
          ? projectStat.stat.complaint
          : 0;
        const greetingConversation = projectStat
          ? projectStat.stat.greeting
          : 0;

        return this.createRow(
          project.name,
          project.code,
          projectType,
          project.contactStat.all,
          project.contactStat.active,
          project.contactStat.closed,
          contactConversation,
          commentConversation,
          complaintConversation,
          greetingConversation
        );
      });
    },
    createTotalStatRow(statRows) {
      return statRows.reduce((totalStat, currentStat) => {
        totalStat.allConversation += currentStat.allConversation;
        totalStat.activeConversation += currentStat.activeConversation;
        totalStat.closedConversation += currentStat.closedConversation;
        totalStat.contactConversation += currentStat.contactConversation;
        totalStat.commentConversation += currentStat.commentConversation;
        totalStat.complaintConversation += currentStat.complaintConversation;
        totalStat.greetingConversation += currentStat.greetingConversation;

        return totalStat;
      }, this.createRow("Total Conversation Summary", "", "", 0, 0, 0, 0, 0, 0, 0));
    },
    createRow(
      projectName,
      projectCode,
      projectType,
      allConversation,
      activeConversation,
      closedConversation,
      contactConversation,
      commentConversation,
      complaintConversation,
      greetingConversation
    ) {
      return {
        projectName: projectName,
        projectCode: projectCode,
        projectType: projectType,
        allConversation: allConversation,
        activeConversation: activeConversation,
        closedConversation: closedConversation,
        contactConversation: contactConversation,
        commentConversation: commentConversation,
        complaintConversation: complaintConversation,
        greetingConversation: greetingConversation
      };
    },
    async getProjectConversationStats(projectIds, dateFilter) {
      const response = await baanRueJaiClient.admin.conversations.getProjectConversationStats(
        {
          projectIds,
          dateFilter
        }
      );

      return response.data;
    },
    lowChange(searchText) {
      this.searchText.lowRise = searchText;
    },
    highChange(searchText) {
      this.searchText.highRise = searchText;
    },
    buildingChange(searchText) {
      this.searchText.buildingRise = searchText;
    },
    noneSCLowChange(searchText) {
      this.searchText.noneSCLowRise = searchText;
    },
    noneSCHighChange(searchText) {
      this.searchText.noneSCHighRise = searchText;
    },
    async handleClickDownloadReport() {
      const { from, to } = this.dateTimeReport;

      try {
        const response = await baanRueJaiClient.admin.conversations.getReport({
          start_at: from.toISO(),
          end_at: to.toISO()
        });

        const blob = new Blob([response.data]);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `report-conversations-${from.toISODate()}-${to.toISODate()}.xlsx`;
        link.click();
      } catch (error) {
        // TODO: use alert message from response message backend
        alert(
          "ไม่สามารถ Download Report ได้ เนื่องจากไม่มีข้อมูลหรือเกิดข้อผิดพลาด"
        );
        console.error(error);
      }
    },
    async setup() {
      await this.setupProjects();
      await this.setupUnreadProjects();
    },
    async setupProjects() {
      const { low_rise,
        high_rise,
        building_rise,
        none_sc_low_rise,
        none_sc_high_rise } = await this.fetchList();

      const lowRise = toCamelCaseObject(low_rise);
      const highRise = toCamelCaseObject(high_rise);
      const buildingRise = toCamelCaseObject(building_rise);
      const noneSCLowRise = toCamelCaseObject(none_sc_low_rise);
      const noneSCHighRise = toCamelCaseObject(none_sc_high_rise);

      this.lowRise = lowRise;
      this.highRise = highRise;
      this.buildingRise = buildingRise;

      this.noneSCLowRise = noneSCLowRise;
      this.noneSCHighRise = noneSCHighRise;

      if (!isEmpty(this.badgesResponse)) {
        this.setupBadge();
      }
    },
    async fetchList() {
      const { from, to } = this.dateTimeReport;

      const response = await baanRueJaiClient.admin.contacts.list({
        start_at: from.toISO(),
        end_at: to.toISO()
      });

      return response.data.result;
    },
    async setupUnreadProjects() {
      this.badgesResponse = await this.getUnreadNewVersion();

      if (
        !isEmpty(this.lowRise.projects) ||
        !isEmpty(this.highRise.projects) ||
        !isEmpty(this.buildingRise.projects) ||
        !isEmpty(this.noneSCLowRise.projects) ||
        !isEmpty(this.noneSCHighRise.projects)
      ) {
        this.setupBadge();
      }
    },
    setupBadge() {
      const unknownUnreadProject = this.badgesResponse.find(
        project => project.projectId === "null"
      );
      this.unknownProject.unread = unknownUnreadProject
        ? unknownUnreadProject.unread
        : 0;

      this.lowRise.projects = this.getProjectsWithUnread(
        this.lowRise.projects
      );
      this.lowRise.projects = this.getSortedProjects(this.lowRise.projects);

      this.highRise.projects = this.getProjectsWithUnread(
        this.highRise.projects
      );
      this.highRise.projects = this.getSortedProjects(this.highRise.projects);

      this.noneSCLowRise.projects = this.getProjectsWithUnread(
        this.noneSCLowRise.projects
      );
      this.noneSCLowRise.projects = this.getSortedProjects(this.noneSCLowRise.projects);

      this.noneSCHighRise.projects = this.getProjectsWithUnread(
        this.noneSCHighRise.projects
      );
      this.noneSCHighRise.projects = this.getSortedProjects(this.noneSCHighRise.projects);

      this.buildingRise.projects = this.getProjectsWithUnread(
        this.buildingRise.projects
      );
      this.buildingRise.projects = this.getSortedProjects(
        this.buildingRise.projects
      );
    },
    getProjectsWithUnread(projects) {
      return projects.map(project => {
        const unreadProject = this.badgesResponse.find(
          unreadProject => unreadProject.projectId === project.id
        );
        const unread = unreadProject ? unreadProject.unread : 0;

        return { ...project, unread };
      });
    },
    getSortedProjects(projects) {
      return projects.sort((a, b) => {
        if (a.unread - b.unread === 0)
          return b.name > a.name ? -1 : b.name < a.name ? 1 : 0;
        else return b.unread - a.unread;
      });
    },
    async getUnreadNewVersion() {
      const response = await baanRueJaiClient.admin.conversations.getUnreadContactProject();

      return response.data;
    },
    async getProjectsData() {
      await this.initData();
    },
    getFilteredProjects(projects, searchText) {
      return !isEmpty(searchText)
        ? projects.filter(project => {
            return (
              project.name.toLowerCase().includes(searchText.toLowerCase()) ||
              project.code.toLowerCase().includes(searchText.toLowerCase())
            );
          })
        : projects;
    },
    getProjectPresenter(filteredProjects, searchText) {
      return {
        projects: filteredProjects,
        totalStat: !isEmpty(searchText)
          ? {
              all: sum(
                filteredProjects.map(project => project.contactStat.all)
              ),
              active: sum(
                filteredProjects.map(project => project.contactStat.active)
              ),
              closed: sum(
                filteredProjects.map(project => project.contactStat.all)
              )
            }
          : this.lowRise.totalStat
      };
    },
    isAllowedRoles(roles) {
      return roles.includes(this.role);
    },
  },
  computed: {
    dateTimeReport() {
      const from = DateTime.fromJSDate(this.defaultReportDate[0]).toUTC();
      const to = DateTime.fromJSDate(this.defaultReportDate[1]).toUTC();

      return { from, to };
    },
    projectsPresenter() {
      const filteredLowRiseProjects = this.getFilteredProjects(
        this.lowRise.projects,
        this.searchText.lowRise
      );
      const lowRise = this.getProjectPresenter(
        filteredLowRiseProjects,
        this.searchText.lowRise
      );

      const filteredHighRiseProjects = this.getFilteredProjects(
        this.highRise.projects,
        this.searchText.highRise
      );
      const highRise = this.getProjectPresenter(
        filteredHighRiseProjects,
        this.searchText.highRise
      );

      const filteredBuildingRiseProjects = this.getFilteredProjects(
        this.buildingRise.projects,
        this.searchText.buildingRise
      );
      const buildingRise = this.getProjectPresenter(
        filteredBuildingRiseProjects,
        this.searchText.buildingRise
      );

      const filteredNoneSCLowRiseProjects = this.getFilteredProjects(
        this.noneSCLowRise.projects,
        this.searchText.noneSCLowRise
      );
      const noneSCLowRise = this.getProjectPresenter(
        filteredNoneSCLowRiseProjects,
        this.searchText.noneSCLowRise
      );

      const filteredNoneSCHighRiseProjects = this.getFilteredProjects(
        this.noneSCHighRise.projects,
        this.searchText.noneSCHighRise
      );
      const noneSCHighRise = this.getProjectPresenter(
        filteredNoneSCHighRiseProjects,
        this.searchText.noneSCHighRise
      );

      return { lowRise, highRise, buildingRise, noneSCLowRise, noneSCHighRise };
    }
  },
  created() {
    this.setup();
  }
};
</script>

<style scoped>
#contact-projects {
  height: calc(100% - 110px);
}

#content-project {
  background-color: red;
}
.card {
  margin-top: 10px;
  margin-bottom: 20px;
  box-shadow: 0 4px 16px 0 rgba(215, 215, 215, 0.7);
}
.card .list-group {
  overflow-y: auto;
}
.project-icon {
  width: 40px;
  height: 40px;
  background-color: #eee;
  border-radius: 15px;
  border: #ccc 1px solid;
}
#contact-projects .list-group-item {
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
.search-input {
  width: 100%;
  height: 27px;
  border-radius: 15px;
  border: solid 1px #e0e0e0;
  font-size: 14px;
  padding: 5px 10px;
}

.stat:after {
  display: block;
  content: "";
  clear: both;
}
.stat .col {
  float: left;
  width: 33.33%;
  text-align: center;
  padding: 5px 0 0 0;
  border-right: solid 1px #ccc;
}
.stat .col:last-child {
  border: none;
}
.stat .stat-ttl {
  font-size: 13px;
  margin-bottom: 0;
}
.stat .count {
  font-size: 14px;
  padding: 5px 0;
}
.sc-btn {
  display: inline-block;
  width: auto;
  padding: 6px 20px;
}

.download-report-message {
  font-size: 15px;
  padding: 9px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/contact/ContactProjects.vue